import * as React from 'react'

export function MotorcycleSafetySexualHarassmentImage() {
  return (
    <svg
      width="295"
      height="208"
      viewBox="0 0 295 208"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="295" height="208" fill="white" />
      <path
        d="M44.9996 48.3754C44.9996 48.3754 54.87 52.1395 59.5124 59.0822C65.3677 67.7815 73.2305 64.3102 78.9185 65.8158C84.6065 67.3214 88.4961 70.2909 90.0854 73.1349C82.599 73.1349 44.8741 73.0513 44.8741 73.0513L44.9996 48.3754Z"
        fill="#D7EBF2"
        fillOpacity="0.5"
      />
      <path
        d="M249.308 7.84802L248.89 57.9527L134.126 58.3709L133.708 8.26626"
        stroke="#B7C1BC"
        strokeMiterlimit="10"
      />
      <path
        d="M184.063 116.546H162.022"
        stroke="#F3F3ED"
        strokeMiterlimit="10"
      />
      <path
        d="M182.976 109.771H160.182"
        stroke="#F3F3ED"
        strokeMiterlimit="10"
      />
      <path
        d="M178.333 116.546L178.291 109.771"
        stroke="#F3F3ED"
        strokeMiterlimit="10"
      />
      <path
        d="M169.258 102.452V109.771"
        stroke="#F3F3ED"
        strokeMiterlimit="10"
      />
      <path
        d="M43.0759 6.71855V74.9328L91.3822 75.351V5.00378"
        stroke="#B7C1BC"
        strokeMiterlimit="10"
      />
      <path
        d="M34 128.426L99.5794 128.886L100.458 5.88269"
        stroke="#C7C6B7"
        strokeMiterlimit="10"
      />
      <path
        d="M43.0759 88.3158L43.3269 113.828L91.424 114.121V88.5249L43.0759 88.3158Z"
        stroke="#B7C1BC"
        strokeMiterlimit="10"
      />
      <path
        d="M104.347 128.424H260.558"
        stroke="#C7C6B7"
        strokeMiterlimit="10"
      />
      <path
        d="M234.126 93.5021L253.323 93.5439L253.657 10.6078"
        stroke="#B7C1BC"
        strokeMiterlimit="10"
      />
      <path
        d="M129.525 64.6023L130.236 93.0423L160.976 93.1678"
        stroke="#B7C1BC"
        strokeMiterlimit="10"
      />
      <path d="M105.1 4H127.183" stroke="#F3F3ED" strokeMiterlimit="10" />
      <path
        d="M106.188 10.7759H128.982"
        stroke="#F3F3ED"
        strokeMiterlimit="10"
      />
      <path
        d="M110.872 4L110.913 10.7754"
        stroke="#F3F3ED"
        strokeMiterlimit="10"
      />
      <path
        d="M119.948 18.095V10.7759"
        stroke="#F3F3ED"
        strokeMiterlimit="10"
      />
      <path
        d="M159.387 85.1373L161.269 96.7225L233.164 96.2206L236.133 85.1373H159.387Z"
        stroke="#B7C1BC"
        strokeMiterlimit="10"
      />
      <path
        d="M159.011 85.0951C159.011 85.0951 160.516 73.2172 170.178 82.0002C169.174 79.3653 169.174 79.3653 169.174 79.3653C169.174 79.3653 171.725 78.0269 175.238 81.5819C174.736 78.487 170.68 72.7572 174.235 72.3389C177.79 71.8789 182.348 79.4071 182.348 79.4071C182.348 79.4071 181.345 73.6773 183.854 75.0156C186.363 76.354 191.466 80.2854 191.466 80.2854C191.466 80.2854 189.458 74.5556 191.968 75.4339C194.519 76.3122 197.028 78.5288 197.028 78.5288C197.028 78.5288 193.683 68.0311 195.523 67.5292C197.363 66.9855 202.131 71.9207 202.131 71.9207C202.131 71.9207 200.625 64.8525 202.633 66.1909C204.64 67.5292 207.693 74.1373 207.693 74.1373C207.693 74.1373 211.248 63.556 213.758 66.1909C216.267 68.8257 219.028 78.1106 219.028 78.1106C219.028 78.1106 220.366 67.0692 222.374 69.244C224.381 71.4606 225.427 77.6087 225.427 77.6087C225.427 77.6087 232.537 69.244 235.046 72.3389C237.597 75.4339 236.301 85.0951 236.301 85.0951H159.011Z"
        fill="#63796D"
      />
      <path
        d="M191.675 87.7304C191.675 87.7304 186.113 76.1034 188.246 76.2289C190.379 76.3544 192.679 80.0767 192.679 80.0767C192.679 80.0767 191.675 77.2745 192.553 77.149C193.432 77.0236 198.743 82.4606 199.998 84.3845"
        stroke="#2B362D"
        strokeWidth="0.65"
        strokeMiterlimit="10"
      />
      <path
        d="M208.195 81.9582C208.195 81.9582 208.697 74.4717 210.077 74.5554C211.458 74.639 213.34 84.593 213.34 84.593"
        stroke="#2B362D"
        strokeWidth="0.65"
        strokeMiterlimit="10"
      />
      <path
        d="M46.4634 201.198H105.016"
        stroke="#C7C6B7"
        strokeWidth="0.65"
        strokeMiterlimit="10"
      />
      <path
        d="M160.767 204H206.69"
        stroke="#C7C6B7"
        strokeWidth="0.65"
        strokeMiterlimit="10"
      />
      <path
        d="M143.996 106.341C143.996 106.341 157.505 84.2161 152.904 74.0948C150.646 69.1178 139.354 57.4072 139.354 57.4072L126.723 103.58L143.996 106.341Z"
        fill="#28362C"
      />
      <path
        d="M162.482 80.4939C162.566 80.7867 162.106 84.2162 160.893 85.3455C159.178 86.0565 157.254 86.3911 156.334 86.2656C151.525 85.6382 143.453 73.9276 139.061 68.5742C137.806 67.0267 135.799 64.6846 135.255 63.4299C134.837 62.4261 134.21 61.5479 134.837 59.4149C134.837 59.4149 136.761 55.4416 140.358 57.5328C140.86 57.8674 162.315 79.9502 162.482 80.4939Z"
        fill="#2B362D"
      />
      <path
        d="M190.504 97.9352C190.88 98.1025 193.934 99.6082 194.477 98.9808C195.021 98.3535 197.321 96.5132 197.656 96.0113C197.99 95.5095 198.158 94.2548 197.99 94.0038C197.865 93.7529 196.317 93.1255 195.439 93.0837C194.561 93.0419 190.713 93.0001 190.337 93.4183C189.96 93.8365 190.002 96.2205 190.002 96.5132C190.002 96.806 190.504 97.9352 190.504 97.9352Z"
        fill="#CEB089"
      />
      <path
        d="M190.504 97.9352C190.504 97.9352 190.88 98.2698 191.508 96.8478C192.135 95.4258 190.462 93.4183 190.462 93.4183C190.462 93.4183 191.215 93.8784 192.093 94.0875C194.268 94.5894 196.317 93.1255 196.861 93.4601C197.154 93.6693 198.827 94.8403 199.705 94.8403C200.123 94.8403 200.834 94.5475 200.667 94.0875C200.458 93.6274 199.12 92.7073 198.409 92.1636C197.614 91.5781 194.143 90.4488 193.39 90.3234C190.88 89.9888 187.033 90.9089 186.447 91.118C185.903 91.3271 186.656 92.4145 186.614 93.2928C186.614 95.1749 190.504 97.9352 190.504 97.9352Z"
        fill="#CEB089"
      />
      <path
        d="M231.24 141.304C226.891 131.183 214.427 101.154 214.427 101.154C214.427 101.154 208.07 103.287 206.899 103.663C198.66 106.005 189.166 108.766 180.843 110.899C180.466 110.982 180.132 111.526 180.132 111.526L191.173 150.422C191.173 150.422 192.051 154.479 192.512 156.486C192.595 156.779 193.055 156.905 193.515 156.779C206.313 152.722 219.571 148.958 232.077 144.357C232.286 144.274 232.411 144.106 232.369 143.981C232.035 143.061 231.617 142.183 231.24 141.304C230.404 139.422 231.617 142.266 231.24 141.304Z"
        fill="#FF3008"
      />
      <path
        d="M208.112 106.884C208.112 106.884 205.184 92.706 204.766 92.2878C204.348 91.8695 194.143 95.2154 187.535 96.972C184.816 97.683 184.9 97.3066 184.481 98.0176C184.063 98.7286 189.333 111.276 189.333 111.276L191.717 110.816L187.116 99.5651L203.26 94.9645L205.686 107.595L208.112 106.884Z"
        fill="#EE0000"
      />
      <path
        d="M197.614 125.495C198.241 126.247 198.283 126.833 199.162 127.335C200.04 127.837 200.542 128.171 200.918 128.046C201.295 127.92 203.679 126.958 205.101 126.582C206.523 126.206 207.694 125.871 208.028 126.54C208.363 127.209 208.488 127.628 207.485 128.046C206.481 128.464 204.264 128.924 203.888 129.175C203.553 129.426 202.089 129.677 202.926 130.179C203.804 130.681 205.77 132.061 206.146 131.894C206.815 131.643 209.325 130.932 210.203 130.597C211.667 130.053 212.169 126.958 211.667 125.662C211.165 124.365 209.283 122.4 207.819 122.651C206.355 122.901 202.215 124.031 201.295 124.282C200.374 124.533 197.614 125.495 197.614 125.495Z"
        fill="white"
      />
      <path
        d="M189.417 89.3611L187.911 97.4749C187.911 97.4749 165.033 91.5359 160.433 90.4485C159.345 90.1976 157.296 89.4866 157.296 89.4866L151.399 84.0077C151.399 84.0077 157.672 77.4414 160.767 78.6961C163.862 79.909 189.417 89.3611 189.417 89.3611Z"
        fill="#2B362D"
      />
      <path
        d="M188.162 96.5963C186.823 96.2617 182.223 93.9196 180.968 93.4595C181.177 92.0793 182.181 90.4482 183.352 88.6498C185.652 89.6535 187.869 90.0299 189.207 90.5737L188.162 96.5963Z"
        fill="#19231C"
      />
      <path
        d="M82.7663 162.97C82.7663 162.97 72.0176 176.103 69.3827 178.612C68.5881 179.407 73.816 184.007 73.816 184.007L86.7813 169.453L82.7663 162.97Z"
        fill="#BEDFE9"
      />
      <path
        d="M75.3219 166.693L87.2834 177.525C87.2834 177.525 101.503 166.442 120.617 144.443C132.495 130.808 142.198 118.554 141.863 116.839C141.11 112.824 126.765 103.497 126.765 103.497C126.765 103.497 121.83 116.797 111.959 127.671C102.089 138.629 77.7894 162.51 75.3219 166.693Z"
        fill="#E5BBB7"
      />
      <path
        d="M71.6832 175.894C71.6832 175.894 68.2119 179.951 66.7062 181.081C65.0333 182.335 63.9041 184.426 63.9041 184.426C63.9041 184.426 69.0902 190.407 71.3905 193.251C73.6908 196.095 76.3257 198.228 78.6259 198.73C80.9262 199.232 88.8309 198.103 88.8309 198.103C88.8309 198.103 88.7054 196.723 86.6979 196.012C84.6904 195.301 80.5917 195.05 79.3788 193.628C78.4168 192.457 77.1203 189.654 76.7857 187.563C76.4093 185.054 77.2039 180.119 77.2039 180.119L71.6832 175.894Z"
        fill="#2B362D"
      />
      <path
        d="M77.413 182.502L75.531 182.92L76.9948 184.426"
        stroke="white"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M77.0783 184.342L75.1126 184.97L76.8274 186.642"
        stroke="white"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M76.8693 186.558L74.9873 187.646L76.9112 188.859"
        stroke="white"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M77.0785 188.692L75.9493 190.616L78.2078 190.992"
        stroke="white"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M77.9148 191.033L77.162 192.539L79.0441 192.79"
        stroke="white"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M78.793 192.833V194.464L80.2987 194.213"
        stroke="white"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M83.9375 195.258C83.9375 195.258 83.4774 197.141 83.101 198.73C84.2302 198.772 86.0705 198.479 86.9906 198.353C88.4963 198.144 88.8308 198.144 88.8308 198.144C88.8308 198.144 88.7054 195.844 83.9375 195.258Z"
        fill="#E6E5D9"
      />
      <path
        d="M62.0638 186.811C62.0638 186.811 67.5845 193.46 68.4628 194.422C69.3411 195.384 73.6071 199.316 75.4055 200.069C77.9985 201.198 80.257 201.24 83.9375 201.156C85.5268 201.114 88.078 200.78 88.329 200.445C88.9563 199.567 88.789 197.81 88.789 197.81C88.789 197.81 83.812 198.73 81.6372 198.772C79.3787 198.814 77.9149 198.228 76.3256 197.392C73.1888 195.677 68.881 190.742 68.5882 190.115C68.2536 189.487 63.9458 184.385 63.9458 184.385C63.9458 184.385 61.8546 185.974 62.0638 186.811Z"
        stroke="#C7C6B7"
        strokeWidth="0.65"
        strokeMiterlimit="10"
      />
      <path
        d="M62.5655 185.346C62.5655 185.346 66.7479 190.532 69.1318 193.167C71.5158 195.802 74.9453 198.814 77.2456 199.608C79.5459 200.403 84.1883 200.068 86.0285 199.692C87.8688 199.315 88.6216 199.106 88.6216 199.106"
        stroke="#2B362D"
        strokeWidth="0.65"
        strokeMiterlimit="10"
      />
      <path
        d="M167.668 167.153C167.668 167.153 174.736 182.544 175.865 186.057C176.2 187.144 182.641 184.426 182.641 184.426L175.238 166.358L167.668 167.153Z"
        fill="#BEDFE9"
      />
      <path
        d="M178.333 200.069C178.333 200.069 200.081 194.966 205.309 191.369C204.18 188.985 200.625 190.366 198.408 190.491C196.819 190.575 188.664 190.073 185.61 187.313C183.352 185.263 181.721 181.75 181.721 181.75L175.364 184.636C175.364 184.636 177.246 190.115 177.246 193.461C177.246 198.73 178.333 200.069 178.333 200.069Z"
        fill="#2B362D"
      />
      <path
        d="M183.561 184.803L183.143 186.685L185.067 186.601"
        stroke="white"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M184.9 186.728L184.482 188.527L186.657 188.15"
        stroke="white"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M186.656 188.024L186.782 190.199L188.706 189.028"
        stroke="white"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M188.748 189.029L189.584 191.078L191.257 189.531"
        stroke="white"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M191.215 189.697L192.386 191.454L194.017 189.907"
        stroke="white"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M193.934 190.032L195.021 191.663L196.401 190.366"
        stroke="white"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M196.443 190.199L197.698 191.704L198.744 190.45"
        stroke="white"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M178.752 201.365C178.752 201.365 186.531 199.358 194.017 197.141C202.759 194.59 205.895 192.833 205.895 192.833"
        stroke="#2B362D"
        strokeWidth="0.65"
        strokeMiterlimit="10"
      />
      <path
        d="M199.831 190.324C199.831 190.324 200.04 192.081 200.333 193.712C204.139 192.374 205.31 191.286 205.31 191.286C205.31 191.286 204.432 188.902 199.831 190.324Z"
        fill="#E6E5D9"
      />
      <path
        d="M180.09 202.83C180.09 202.83 192.093 200.027 196.777 198.313C201.587 196.556 206.062 194.632 206.313 194.088C206.606 193.545 205.31 191.412 205.31 191.412C205.31 191.412 195.523 195.26 187.158 197.476C183.185 198.522 177.999 199.609 177.999 199.609C177.999 199.609 178.584 202.202 180.09 202.83Z"
        stroke="#C7C6B7"
        strokeWidth="0.65"
        strokeMiterlimit="10"
      />
      <path
        d="M120.909 160.921H120.951C120.951 160.921 120.909 160.963 120.909 160.921Z"
        stroke="#9DC8CF"
        strokeWidth="0.5438"
        strokeMiterlimit="10"
      />
      <path
        d="M139.354 57.3658C139.354 56.6966 144.916 64.9777 146.338 70.0383C146.966 72.1713 146.255 74.7226 146.171 75.6427C145.376 82.5436 143.62 94.296 143.62 94.296L126.514 94.1705L131.198 56.4457L139.354 57.3658Z"
        fill="white"
      />
      <path
        d="M140.065 51.3012C139.354 53.7688 139.438 59.4568 139.438 59.4568C139.438 59.4568 136.008 59.8751 132.077 57.7002C133.75 50.172 133.833 45.7805 133.833 45.7805L140.065 51.3012Z"
        fill="#CEB089"
      />
      <path
        d="M142.239 35.0327C142.574 35.911 144.247 40.3025 145.042 43.272C145.334 44.3175 145.293 45.0704 145.125 45.6977C144.372 48.4581 144.665 50.4238 143.829 51.4694C142.909 52.5986 141.194 52.5568 138.559 52.0967C133.666 51.2184 128.479 46.7433 132.202 39.4242C133.666 36.5384 137.806 35.7437 139.312 35.9947C140.901 36.2038 142.239 35.0327 142.239 35.0327Z"
        fill="#D8BB91"
      />
      <path
        d="M144.163 40.5109L144.916 42.6439C145.293 43.4803 145.585 44.1913 146.004 45.1115C146.129 45.3206 146.213 45.5297 146.004 45.7388C145.585 46.1989 144.749 46.1152 144.749 46.1152L144.163 40.5109Z"
        fill="#D8BB91"
      />
      <path
        d="M142.532 35.0324C143.118 33.945 141.068 32.8994 139.396 31.9375C136.802 30.4318 132.62 30.641 128.856 33.0249C126.096 34.7815 123.795 40.7204 125.928 45.6974C127.559 49.5452 127.936 53.9367 129.567 53.5603C131.658 53.0584 136.342 48.4578 138.475 44.861C141.194 40.2186 142.365 35.3252 142.532 35.0324Z"
        fill="#28362C"
      />
      <path
        d="M143.494 46.2821C144.718 46.2821 145.711 44.859 145.711 43.1035C145.711 41.348 144.718 39.9249 143.494 39.9249C142.27 39.9249 141.277 41.348 141.277 43.1035C141.277 44.859 142.27 46.2821 143.494 46.2821Z"
        stroke="#2B362D"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M141.278 43.48L136.217 43.5636"
        stroke="#2B362D"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M131.365 36.747C131.365 36.747 130.069 40.6366 126.054 41.3058C122.039 41.975 118.986 38.0854 115.682 34.0703C113.465 31.31 113.8 28.8842 109.826 29.2606C105.853 29.637 106.188 31.6445 102.591 31.1008C98.994 30.5571 97.8229 25.1619 93.9333 26.9603L83.0174 40.8876C83.0174 40.8876 82.5991 51.2598 100.29 49.7542C106.606 49.6287 102.967 53.7692 109.743 55.944C119.948 59.2481 134.46 52.9327 134.586 48.5831C134.669 45.279 125.887 47.4957 125.426 44.108C124.966 40.7203 130.905 36.287 131.365 36.747Z"
        fill="#28362C"
      />
      <path
        d="M83.8541 35.9943C83.8541 35.9943 83.8541 43.3552 92.177 45.3627C100.5 47.3703 104.431 39.1729 110.287 45.6973C115.347 51.3853 119.279 52.9328 132.035 46.1574"
        stroke="#3B646E"
        strokeWidth="0.65"
        strokeMiterlimit="10"
      />
      <path
        d="M88.8308 50.5488C94.5606 52.8909 99.7468 50.1724 102.256 51.8872C104.766 53.6019 103.302 57.7425 110.412 58.328"
        stroke="#28362C"
        strokeWidth="0.65"
        strokeMiterlimit="10"
      />
      <path
        d="M87.5763 30.349C87.5763 30.349 88.0364 35.5769 95.5646 35.7024C103.093 35.8697 103.553 32.7748 108.53 34.7823C113.549 36.7898 114.009 41.976 117.857 42.6033C121.704 43.2307 125.845 41.2231 125.845 41.2231"
        stroke="#3B646E"
        strokeWidth="0.65"
        strokeMiterlimit="10"
      />
      <path
        d="M124.13 32.4815C123.46 33.2344 122.875 34.5727 125.384 35.4092C126.806 35.8692 123.168 43.1884 126.514 44.5685C132.913 42.7283 141.57 35.8274 142.532 34.9909C143.201 34.4054 141.026 31.9796 138.308 30.2649C131.491 25.9152 125.928 30.3903 124.13 32.4815Z"
        fill="#E2F3F7"
      />
      <path
        d="M125.636 33.7365C125.636 35.3257 124.004 36.455 122.415 36.5386C120.24 36.6641 118.86 34.6984 118.86 33.1091C118.86 31.5198 121.119 30.4324 122.708 30.4324C124.339 30.3906 125.636 32.1053 125.636 33.7365Z"
        fill="#9DC8CF"
      />
      <path
        d="M131.575 53.0991L130.654 58.4944L137.89 62.9277L141.487 57.4906C141.487 57.5324 131.198 54.0192 131.575 53.0991Z"
        fill="white"
      />
      <path
        d="M126.598 93.2922C126.598 93.2922 124.423 104.794 127.476 108.432C158.342 145.153 162.106 173.05 164.992 175.977C165.995 177.023 181.303 170.624 181.303 170.624C181.303 170.624 172.52 140.678 166.372 130.599C160.224 120.561 143.578 94.1705 143.578 94.1705L126.598 93.2922Z"
        fill="#F2D1CD"
      />
      <path
        d="M140.274 40.5521C140.274 40.5521 137.221 51.8027 128.187 55.8596"
        stroke="#28362C"
        strokeWidth="0.65"
        strokeMiterlimit="10"
      />
      <path
        d="M137.89 62.9283L127.057 113.409H87.4087C87.4087 113.409 88.8307 105.296 92.4275 102.577C101.21 95.8853 108.697 94.2123 110.37 87.1442C112.043 80.076 112.461 67.5289 119.153 64.6012C125.845 61.6736 132.494 57.073 132.494 57.073L137.89 62.9283Z"
        fill="#3C5749"
      />
      <path
        d="M117.856 89.6546L109.617 77.4003C109.617 77.4003 113.8 75.6437 116.56 74.5981C127.225 70.6249 135.841 66.2334 135.841 66.2334L132.453 57.4504L104.264 67.6972C104.264 67.6972 99.0776 69.9139 97.8647 71.0431C96.6519 72.1305 97.572 77.5258 97.572 77.5258L112.001 97.0992L117.856 89.6546Z"
        fill="#3C5749"
      />
      <path
        d="M126.472 70.7505L109.617 77.4004L117.856 89.6547"
        stroke="#28362C"
        strokeWidth="0.65"
        strokeMiterlimit="10"
      />
      <path
        d="M120.91 85.4722C120.91 85.4722 113.967 94.0878 108.948 99.9431C113.967 98.8139 123.126 94.6734 123.126 94.6734L120.91 85.4722Z"
        fill="#E6E5D8"
      />
      <path
        d="M140.399 96.3046C140.399 96.3046 139.019 103.247 132.034 106.593"
        stroke="#D3A19F"
        strokeWidth="0.65"
        strokeMiterlimit="10"
      />
      <path
        d="M195.188 99.9839C196.275 100.277 200.625 97.0562 200.918 96.3871C201.211 95.7597 197.656 92.372 195.439 92.9994C193.222 93.6267 191.047 95.8015 191.508 96.8471C191.968 97.8927 195.188 99.9839 195.188 99.9839Z"
        fill="#D8BB91"
      />
      <path
        d="M124.13 32.4812C123.502 33.1922 122.959 34.447 125.05 35.2834C125.426 34.8652 125.635 34.3215 125.635 33.736C125.635 33.025 125.385 32.2721 124.924 31.6448C124.632 31.9375 124.339 32.2303 124.13 32.4812Z"
        fill="#6FACB2"
      />
      <path
        d="M137.89 62.9283L132.453 57.073C132.453 57.073 131.909 57.4494 130.989 58.0349L126.514 94.1287L131.156 94.1705L137.89 62.9283Z"
        fill="#63796D"
      />
      <path
        d="M77.7896 168.951L82.9757 173.677L86.7816 169.411L82.7666 162.97C82.7666 162.97 80.5081 165.73 77.7896 168.951Z"
        fill="#D8A19E"
      />
      <path
        d="M79.2112 163.64C79.2112 163.64 88.3706 172.8 91.4655 174.765"
        stroke="#C68D8D"
        strokeWidth="0.65"
        strokeMiterlimit="10"
      />
      <path
        d="M175.238 166.358L167.668 167.153C167.668 167.153 169.257 170.582 171.014 174.555C173.231 173.803 175.656 172.841 177.58 172.088L175.238 166.358Z"
        fill="#E5BBB7"
      />
      <path
        d="M162.357 172.8C162.357 172.8 173.774 169.746 178.5 167.53"
        stroke="#D3A19F"
        strokeWidth="0.65"
        strokeMiterlimit="10"
      />
      <path
        d="M151.734 83.6316C153.407 85.1373 154.996 86.141 156.334 86.3083C157.213 86.4338 159.178 86.0992 160.893 85.3882C162.064 84.259 162.524 80.7876 162.482 80.5367C162.44 80.453 161.855 79.7838 160.893 78.7383C160.851 78.7383 160.809 78.6964 160.768 78.6964C158.091 77.609 153.114 82.2514 151.734 83.6316Z"
        fill="#19231C"
      />
      <path
        d="M142.532 34.9912C142.532 34.9912 142.574 34.9493 142.574 34.9075C142.616 34.7402 142.658 34.6148 142.616 34.4475C142.574 34.3638 142.532 34.2802 142.491 34.1547C142.031 33.3601 140.609 32.6072 139.396 31.8962C136.803 30.3906 132.62 30.5997 128.856 32.9836C126.598 34.4056 124.632 38.6716 125.176 42.9377C125.385 43.6487 125.761 44.2342 126.472 44.5688C132.871 42.7285 141.529 35.8276 142.532 34.9912Z"
        fill="#BEDFE9"
      />
      <path
        d="M125.635 43.0208C125.635 43.0208 139.061 35.7853 141.779 33.1923"
        stroke="white"
        strokeWidth="0.65"
        strokeMiterlimit="10"
      />
      <path
        d="M180.884 55.4428C180.884 55.4428 183.059 47.0781 197.237 47.2872C211.416 47.4963 222.415 38.5879 224.841 33.4854C228.103 26.6682 236.97 13.5356 246.255 14.1629C246.255 18.9726 245.962 54.9409 245.962 54.9409L180.884 55.4428Z"
        fill="#D7EBF2"
        fillOpacity="0.5"
      />
    </svg>
  )
}
